(function($) {
	'use strict';
	$.fn.Slide__Details = function() {
		this.each(function() {

			/*
			 * Action: Open slide to view details / edit overlay
			 */
			var $self = $(this),
				view_type = $self.data('type');
			$self.off( $.Globals.clickEvent ).on( $.Globals.clickEvent, function(e) {
				e.preventDefault();

				// Activate Trigger (and clean siblings)
				var $grid_item = $self.closest('.component-slide-grid-item');
				$grid_item.addClass('active').siblings('.active').removeClass('active');

				// Get options
				var slide_data = JSON.parse( $self.siblings('.slide-data').html() ),
					slide_edit_overlay, collection_type;

				// If in collection, we have a collection_slide
				if( slide_data.collection_id !== undefined ) {
					collection_type = 'personal';
				} else {
					collection_type = 'steelcase';
				}
				slide_edit_overlay = $('#slide--details').html();

				// Add some client side data
				// Total slides in this zone / collection
				console.log(view_type);
				if( view_type === 'grid' ) {
					slide_data.current_slide_i = $grid_item.index() + 1;
					slide_data.total_num_slides = $grid_item.siblings().length + 1;
				}else if( view_type === 'list' ) {
					const $grid_item_container = $grid_item.closest('.component-slide-list-item');
					slide_data.current_slide_i = $grid_item_container.index();
					slide_data.total_num_slides = $grid_item_container.siblings().length;
				}
				console.log(slide_data);
				// Parse it
				Mustache.parse( slide_edit_overlay );
				var output = Mustache.render( slide_edit_overlay, slide_data );

				// Add it to dom and fade it in
				$.Body.append( output );

				// Fade it in
				setTimeout( function() {

					$.Body.addClass('overlay-white-on');

					// Add global close overlay listener
					$.Globals.listenForGlobalCloseOverlay( function() {
						$('#grid-list .component-slide-grid-item.active').removeClass('active');
					});

				}, 10 );


				// Accordions
				var $overlay = $('#overlay-white.slide--details');
				$overlay.find('[data-controller]').each( function() {
					$(this).Instantiate();
				});

				// Activate the first accordion item
				if( collection_type === 'steelcase' ) {
					$overlay.find('.accordion-trigger').first().trigger('click.accordion-trigger');
				}

			});


		});
		return this;
	};
}(jQuery));
